/*  ========================================================================
    # Sections - BookingPanel
    ========================================================================  */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useTranslation from '@/react/hooks/useTranslation';
// import GuestSelection from './GuestSelection';
import TravelRange from './TravelRange';
import { format } from 'date-fns';

const BookingPanel = ({ defaultVoucherCode, bookingEngineUrl, locale }) => {
  const __ = useTranslation();
  // const [rooms, setRooms] = useState();
  const [travelRange, setTravelRange] = useState({ startDate: new Date(), endDate: new Date() });
  const [voucherCode, setVoucherCode] = useState(defaultVoucherCode);
  const voucherFieldId = `voucher-${Math.floor(Math.random() * 999999999)}`;

  // const handleGuestChange = rooms => {
  //   setRooms(rooms);
  // };

  const handleTravelRangeChange = dates => {
    setTravelRange(dates);
  };

  // generate booking url
  const formatDate = date => {
    if (!date || !(date instanceof Date)) return undefined;
    return format(date, 'dd.MM.RR');
  };

  const getBookingUrl = () => {
    // const adultsCount = rooms.reduce((acc, room) => acc + room.adults, 0);
    // const childrenCount = rooms.reduce((acc, room) => acc + room.children + room.toddler, 0);

    const u = new URL(bookingEngineUrl);
    u.searchParams.set('arrival', formatDate(travelRange.startDate));
    u.searchParams.set('departure', formatDate(travelRange.endDate));

    // if (rooms) {
    //   u.searchParams.set('rooms', rooms.length);
    // }

    // u.searchParams.set('adults', adultsCount);
    // u.searchParams.set('children', childrenCount);
    if (voucherCode) {
      u.searchParams.set('bookingcode', voucherCode);
    }
    u.searchParams.set('lang', locale);
    u.searchParams.set('filter', true);

    return u.toString();
  };

  return (
    <div className='container'>
      <div className='s-booking-panel__wrapper'>
        <div className='s-booking-panel__items'>
          {/*
            TEMPORARY REMOVED
            <GuestSelection onGuestChange={handleGuestChange} />
          */}
          <TravelRange locale={locale} onDateChanged={handleTravelRangeChange} />
          <div className='s-booking-panel__item'>
            <label for={voucherFieldId} className='s-booking-panel__item-label'>{__('booking-panel-voucher')}</label>
            <input
              type='text'
              className='s-booking-panel__voucher'
              placeholder={__('booking-panel-voucher-placeholder')}
              value={voucherCode}
              onChange={e => setVoucherCode(e.target.value)}
              id={voucherFieldId}
            />
          </div>
        </div>
        <button
          type='button'
          title={__('booking-panel-button')}
          aria-label={__('booking-panel-button')}
          className='s-booking-panel__button c-button'
          onClick={() => window.open(getBookingUrl(), '_blank')}
        >
          {__('booking-panel-button')}
        </button>
      </div>
    </div>
  );
};

BookingPanel.propTypes = {
  defaultVoucherCode: PropTypes.string,
  bookingEngineUrl: PropTypes.string,
  locale: PropTypes.string
};

export default BookingPanel;
